module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "describe"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("销售额")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v(_vm._s(this.salesAmount))])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("订单客户")]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('p', {
    staticClass: "num"
  }, [_vm._v(_vm._s(this.orderCustomer))])])])])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("销售数据")]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "main"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eaa5e856!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/salesDataCenter/components/center/index.vue
// module id = 2104
// module chunks = 2